import { render } from "./EditShippingMethod.vue?vue&type=template&id=cfe593c8&scoped=true&ts=true"
import script from "./EditShippingMethod.vue?vue&type=script&lang=ts"
export * from "./EditShippingMethod.vue?vue&type=script&lang=ts"

import "./EditShippingMethod.vue?vue&type=style&index=0&id=cfe593c8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfe593c8"]])

export default __exports__